function createStartTemplate() {
  return {
    id: 'sys-start',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'Start',
    subtitle: 'Entry point of the workflow',
    label: 'Start',
    icon: 'start',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    hyperparameters: []
  };
}

function createConditionTemplate() {
  return {
    id: 'sys-condition',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'Condition',
    subtitle: 'Route by yes/no rule',
    label: 'Condition',
    icon: 'condition',
    borderColor: '',
    conditionRule: {
      mode: 'simple',
      logic: 'and',
      conditions: [
        {
          id: 'cond-default',
          operator: 'equals',
          value: ''
        }
      ]
    },
    options: null,
    stats: null,
    hyperparameters: [
      { id: 'cond-var', key: 'variable', type: 'any', default: '' }
    ]
  };
}

function createVariablesTemplate() {
  return {
    id: 'sys-variables',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'Variable',
    subtitle: 'Store typed context values',
    label: 'Variable',
    icon: 'variables',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    hyperparameters: [
      { id: 'var-data-type', key: 'dataType', type: 'string', default: 'string' },
      { id: 'var-value', key: 'value', type: 'string', default: '' },
      { id: 'var-retain', key: 'retain', type: 'boolean', default: 'false' }
    ]
  };
}

function createSetVariableTemplate() {
  return {
    id: 'sys-set-variable',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'Set Variable',
    subtitle: 'Update a variable at runtime',
    label: 'Set Variable',
    icon: 'set-variable',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    hyperparameters: [
      { id: 'setvar-variable', key: 'variable', type: 'string', default: '' },
      { id: 'setvar-source', key: 'source', type: 'boolean', default: 'false' },
      { id: 'setvar-value', key: 'value', type: 'string', default: '' }
    ]
  };
}

function createConsoleLogTemplate() {
  return {
    id: 'sys-console-log',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'Console.Log',
    subtitle: '',
    label: 'Console.Log',
    icon: 'console-log',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    hyperparameters: []
  };
}

function createComputerUseTemplate() {
  return {
    id: 'sys-computer-use',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'Computer Use',
    subtitle: 'Use a computer terminal to use tool and complete the task',
    label: 'Computer Use',
    icon: 'computer-use',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    hyperparameters: [
      { id: 'computer-use-prompt', key: 'prompt', type: 'multiline', rows: 6, default: '' },
      { id: 'computer-use-max-tokens', key: 'maxTokens', type: 'number', default: 4000 }
    ]
  };
}

// Tool-calling agent: an LLM that reads its input and decides which of the
// nodes connected to its BOTTOM "tools" anchor to call as tools, looping with
// each tool's result until it produces a final answer on its RIGHT output.
// Three distinct anchors (see nodeTypes.getNodeAnchors):
//   left  = input          (normal flow in)
//   right = result output  (normal flow continues with the final answer)
//   bottom-tools = tool nodes (callable tools, NOT normal downstream flow)
function createToolAgentTemplate() {
  return {
    id: 'sys-tool-agent',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'Tool Calling',
    subtitle: '',
    label: 'Tool Calling',
    icon: 'tool-agent',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    // Config is edited in the AgentSettingsEditor popover (opened from the
    // node's edit button), not the sidebar form — so these are plain values the
    // popover reads/writes: `prompt` (instruction) + `aiTier` (model tier).
    hyperparameters: [
      { id: 'tool-agent-prompt', key: 'prompt', type: 'multiline', rows: 6, default: '', hint: 'If set, this overrides any input coming from the connection. Leave empty to use the connected input as the task.' },
      { id: 'tool-agent-instructions', key: 'additionalInstructions', label: 'Additional Instructions', type: 'multiline', rows: 6, default: '', hint: 'Optional standing guidance for how the agent should behave across the whole run (e.g. tone, constraints, "always cite sources"). Added to the agent\'s system rules — separate from the task above.' },
      { id: 'tool-agent-tier', key: 'aiTier', type: 'string', default: 'balance' }
    ]
  };
}

function createClassifierTemplate() {
  return {
    id: 'sys-classifier',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'Classify',
    subtitle: 'Classify',
    label: 'Classify',
    icon: 'classifier',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    hyperparameters: [
      { id: 'clf-labels', key: 'labels', type: 'string', default: 'positive,negative,neutral' },
      { id: 'clf-instruction', key: 'instruction', type: 'multiline', rows: 4, default: '' }
    ]
  };
}

function createRouterTemplate() {
  return {
    id: 'sys-router',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'Router',
    subtitle: 'Router',
    label: 'Router',
    icon: 'router',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    hyperparameters: [
      { id: 'rtr-labels', key: 'labels', type: 'string', default: 'option1,option2,option3' }
    ]
  };
}

function createLoopTemplate() {
  return {
    id: 'sys-loop',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'Loop',
    subtitle: 'Iterate over a list',
    label: 'Loop',
    icon: 'loop',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    hyperparameters: [
      { id: 'loop-items-path', key: 'itemsPath', type: 'string', default: '' }
    ]
  };
}

function createSleepTemplate() {
  return {
    id: 'sys-sleep',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'Sleep',
    subtitle: 'Pause execution for a duration',
    label: 'Sleep',
    icon: 'sleep',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    hyperparameters: [
      { id: 'sleep-duration', key: 'duration', type: 'number', default: 1000 },
      { id: 'sleep-unit', key: 'unit', type: 'string', default: 'ms' }
    ]
  };
}

// Template used when a user drags a .flw file from the workbook explorer
// onto the canvas. The dropped flow becomes a node whose hyperparameters are
// the start parameters of the referenced flow. Hyperparameters are populated
// at drop time (see WorkflowCanvas.onCanvasDrop) — the template itself starts
// empty so it never produces stale fields.
// Browser-run drives the user's REAL Chrome via the Alleflow Chrome
// extension (browser_run_ext/). Vision-based AI automation; four output
// branches: success, need_info, failed, stopped. The labels hp is fixed —
// the runtime fan-out depends on this exact list to wire each output
// anchor to the right branch.
function createBrowserRunTemplate() {
  return {
    id: 'sys-browser-run',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'Browser Run',
    subtitle: 'Drive a real Chrome tab to reach a goal',
    label: 'Browser Run',
    icon: 'browser-run',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    // Two visible inputs (Goal + Start URL) rendered by
    // BrowserRunRecorderEditor; labels stays as a hidden default that
    // wires the 4 classifier-style output anchors.
    hyperparameters: [
      { id: 'br-goal',       key: 'goal',       type: 'multiline', default: '' },
      { id: 'br-webpageUrl', key: 'webpageUrl', type: 'string',    default: '' },
      { id: 'br-labels',     key: 'labels',     type: 'string',    default: 'success,need_info,failed,stopped' }
    ]
  };
}

// Browser Action drives the user's REAL Chrome via the Browser Action
// extension (browser_action_ext/) — the deterministic, non-AI browser
// node. The user picks the target element once at setup time (selector
// stored in hyperparameters); at run time the node replays one action
// (click / type / extract / navigate) in a tab that is shared by every
// browser-action node in the same run and closed when the run ends.
function createBrowserActionTemplate() {
  return {
    id: 'sys-browser-action',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'Browser Action',
    subtitle: 'Click, type or read on a real webpage',
    label: 'Browser Action',
    icon: 'browser-action',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    // Rendered by BrowserActionEditor (selector/selectorLabel are filled
    // by the "Pick element" flow, not typed by hand).
    hyperparameters: [
      { id: 'ba-url',           key: 'url',           type: 'string',    default: '' },
      { id: 'ba-action',        key: 'action',        type: 'string',    default: 'click' },
      { id: 'ba-selector',      key: 'selector',      type: 'string',    default: '' },
      { id: 'ba-selectorLabel', key: 'selectorLabel', type: 'string',    default: '' },
      { id: 'ba-fingerprint',   key: 'fingerprint',   type: 'string',    default: '' },
      // 'true' when an extract pick chose "all similar elements" — the
      // node then outputs a JSON array (one item per match).
      { id: 'ba-multi',         key: 'multi',         type: 'string',    default: '' },
      // JSON array of recorded steps [{action, selector, selectorLabel,
      // fingerprint, value, typingDelayMs, fullPage, scrollDirection,
      // scrollMode, scrollDistancePx, scrollDurationMs}] — when non-empty the node runs
      // the sequence and the single action/selector fields are ignored.
      { id: 'ba-steps',         key: 'steps',         type: 'string',    default: '' },
      { id: 'ba-value',         key: 'value',         type: 'multiline', default: '' },
      { id: 'ba-delayMs',       key: 'delayMs',       type: 'number',    default: 0 },
      // Tab inheritance: 'new' opens this node's own tab; 'continue' reuses
      // the tab of the Browser Action node referenced by continueFrom (node id).
      { id: 'ba-tabMode',       key: 'tabMode',       type: 'string',    default: 'new' },
      { id: 'ba-continueFrom',  key: 'continueFrom',  type: 'string',    default: '' },
      // 'true' → close the session tab once this node's action(s) finish
      // (don't check it on nodes other browser-action nodes continue from).
      { id: 'ba-closeTab',      key: 'closeTab',      type: 'string',    default: '' }
    ]
  };
}

// Haiku runs on the Alleflow API and drives the user's real Chrome tab from
// fresh viewport screenshots. The extension never receives provider keys.
function createBrowserAgenticActionTemplate() {
  return {
    id: 'sys-browser-agentic-action',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'Browser Agentic Action',
    subtitle: 'Let AI complete a task from browser screenshots',
    label: 'Browser Agentic Action',
    icon: 'browser-agentic-action',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    hyperparameters: [
      { id: 'baa-task',             key: 'task',             type: 'multiline', default: '' },
      { id: 'baa-url',              key: 'url',              type: 'string',    default: '' },
      { id: 'baa-tabMode',          key: 'tabMode',          type: 'string',    default: 'new' },
      { id: 'baa-continueFrom',     key: 'continueFrom',     type: 'string',    default: '' },
      { id: 'baa-closeTab',         key: 'closeTab',         type: 'string',    default: '' }
    ]
  };
}

// Apify node: runs a public Apify Store actor. The user searches the Store
// for an actor, the editor pulls that actor's input schema and renders a
// dynamic form for it (see ApifyEditor), and at run time the node calls the
// actor with the assembled input and outputs its dataset items. All fields
// are edited by ApifyEditor — not the generic hyperparameter form — so they
// live here purely to seed paramValues and persist with the node.
function createApifyTemplate() {
  return {
    id: 'sys-apify',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'Apify',
    subtitle: 'Run an Apify Store actor',
    label: 'Apify',
    icon: 'apify',
    logoUrl: 'https://downloads.rankmyai.com/uploads/logos/apify-com-logo.png',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    hyperparameters: [
      // Apify API token (per-node). Runs use it; Store search does not.
      { id: 'apify-apiKey',      key: 'apiKey',      type: 'string', default: '' },
      // Selected actor: id is used verbatim in the API path; title is display.
      { id: 'apify-actorId',     key: 'actorId',     type: 'string', default: '' },
      { id: 'apify-actorTitle',  key: 'actorTitle',  type: 'string', default: '' },
      // Cached { rating, reviewCount, pricing } for the picked actor (display only).
      { id: 'apify-actorMeta',   key: 'actorMeta',   type: 'string', default: '' },
      // Cached input schema (JSON string) — drives the dynamic input form.
      { id: 'apify-inputSchema', key: 'inputSchema', type: 'string', default: '' },
      // Assembled actor input object (JSON string) sent to the actor at run time.
      { id: 'apify-input',       key: 'input',       type: 'string', default: '{}' }
    ]
  };
}

function createFlowRefTemplate() {
  return {
    id: 'sys-flow-ref',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'Flow',
    subtitle: 'Run another flow as a node',
    label: 'Flow',
    icon: 'flow-ref',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    hyperparameters: []
  };
}

function createFilePreviewTemplate() {
  return {
    id: 'sys-file-preview',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'File Preview',
    subtitle: 'Preview a file from URL',
    label: 'File Preview',
    icon: 'file-preview',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    hyperparameters: [
      { id: 'fp-url', key: 'url', type: 'string', default: '' }
    ]
  };
}

function createOnFailTemplate() {
  return {
    id: 'sys-on-fail',
    kind: 'workflow-node',
    nodeType: 'card',
    category: 'system',
    title: 'On Fail',
    subtitle: 'Runs when the connected node fails',
    label: 'On Fail',
    icon: 'on-fail',
    borderColor: '',
    conditionRule: null,
    options: null,
    stats: null,
    hyperparameters: []
  };
}

// Note: createFlowRefTemplate is intentionally NOT included in objectTemplates.
// Flow-ref nodes are only created via drag-and-drop from the workbook explorer
// (a .flw file dropped on the canvas), so we don't want a free-floating flow-ref
// entry in the sidebar's System Objects list.
// File Preview is intentionally omitted from the sidebar — it's still a valid
// node type (planner can emit it, saved workflows load it), but users don't
// add it manually from the System Objects list.
// Browser Run (the AI goal-driven node) stays intentionally omitted from
// the sidebar — still wired end-to-end (planner can emit it, saved
// workflows load and run it), but the user-facing browser node is the
// deterministic Browser Action below.
var objectTemplates = [createStartTemplate(), createConditionTemplate(), createVariablesTemplate(), createSetVariableTemplate(), createToolAgentTemplate(), createClassifierTemplate(), createRouterTemplate(), createBrowserActionTemplate(), createBrowserAgenticActionTemplate(), createOnFailTemplate()];

// System templates: code-shipped, built-in entries that appear in every user's
// "Templates" section (not the permanent "System Objects" list). They are
// available to everyone by default but can be deleted/hidden per user. Marked
// with isSystemTemplate so the sidebar can route their delete to a local hide
// (rather than the per-user custom-object delete API).
var systemTemplates = [
  Object.assign(createApifyTemplate(), { isSystemTemplate: true })
];

module.exports = {
  objectTemplates: objectTemplates,
  systemTemplates: systemTemplates,
  createFlowRefTemplate: createFlowRefTemplate
};
